module.exports = require("core-js/library/fn/object/assign");


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@babel_runtime-corejs2@7.17.7@@babel/runtime-corejs2/core-js/object/assign.js
// module id = wQ2l
// module chunks = 16